import { render } from "./SubmitButton.vue?vue&type=template&id=75a7f380&scoped=true&ts=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"

import "./SubmitButton.vue?vue&type=style&index=0&id=75a7f380&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a7f380"]])

export default __exports__